var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"van-fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"backtop",style:({
      'right': _vm.styleRight,
      'bottom': _vm.styleBottom
    }),on:{"click":function($event){$event.stopPropagation();return _vm.handleClick($event)}}},[_vm._t("default",[_c('img',{attrs:{"src":require("@/assets/images/backtop.png"),"alt":"backtop"}})])],2)])}
var staticRenderFns = []

export { render, staticRenderFns }